import React from 'react';
import { CONSTANTS } from 'services/constants';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import moment from 'moment/moment';
import PendingPayments from './Loadable';

function Card()
{
    const closedDate = {
        min: moment().subtract(90, 'days').format(CONSTANTS.FORMATS.DATE_DATABASE),
        max: moment().format(CONSTANTS.FORMATS.DATE_DATABASE),
    };

    return (
        <CollapsibleCard
            titleType="primary"
            title="Upcoming Bookings & Payment Status"
            subtitle="Next 15 days"
            subtitleMargin=""
            subtitlePadding=""
            titleMargin="tw-pb-2 tw-pt-2"
            customButtonBg="tw-bg-primary-default tw-text-black hover:tw-text-white"
            boxMargin="tw-mt-3"
            customBg="tw-bg-transparent"
            before={false}
            storeId="pending_payments"
            defaultState
        >
            <PendingPayments
                hideColumns={['Client']}
                closedDate={closedDate}
                fixedSize
                hidePagination
                report="recent_bookings"
            />
        </CollapsibleCard>
    );
}

export default Card;
